// Auth
export const SIGNIN = 'SIGNIN'
export const SIGNIN_SUCCESS = 'SIGNIN_SUCCESS'
export const SIGNIN_FAIL = 'SIGNIN_FAIL'

export const CADASTRO = 'CADASTRO'
export const CADASTRO_SUCCESS = 'CADASTRO_SUCCESS'
export const CADASTRO_FAIL = 'CADASTRO_FAIL'

export const CADASTRO_USER = 'CADASTRO_USER'

// Documentos
export const DOCUMENTOS = 'DOCUMENTOS'
export const DOCUMENTOS_SUCCESS = 'DOCUMENTOS_SUCCESS'
export const DOCUMENTOS_FAIL = 'DOCUMENTOS_FAIL'
export const LISTA_DOCUMENTOS = 'LISTA_DOCUMENTOS'

export const DOCUMENTO_ADICIONADO = 'DOCUMENTO_ADICIONADO'
export const DOCUMENTO_ADICIONADO_FAIL = 'DOCUMENTO_ADICIONADO_FAIL'

export const SIG = 'SIG'
export const SIG_SUCCESS = 'SIG_SUCCESS'
export const SIG_FAIL = 'SIG_FAIL'

export const DOC_SELECTED = 'DOC_SELECTED'
export const DOC_NOT_SELECTED = 'DOC_NOT_SELECTED'

export const SIG_CONTATAR_SUCCESS = 'SIG_CONTATAR_SUCCESS'
export const SIG_CONTATAR_FAIL = 'SIG_CONTATAR_FAIL'

export const SIG_REMOVE = 'SIG_REMOVE'

export const EXIBIR_DOC = 'EXIBIR_DOC'
export const EXIBIR_DOC_SUCCESS = 'EXIBIR_DOC_SUCCESS'
export const EXIBIR_DOC_FAIL = 'EXIBIR_DOC_FAIL'

export const BAIXAR_DOC = 'BAIXAR_DOC'

export const CHANGE_STATUS = 'CHANGE_STATUS'
export const CHANGE_STATUS_SUCCESS = 'CHANGE_STATUS_SUCCESS'
export const CHANGE_STATUS_FAIL = 'CHANGE_STATUS_FAIL'

export const AGRUPADOR = 'AGRUPADOR'
export const ADDSTATE = 'ADDSTATE'


// SIGNITARIO

export const LOGIN_SIG = 'LOGIN_SIG'
export const LOGIN_SIG_SUCCESS = 'LOGIN_SIG_SUCCESS'
export const LOGIN_SIG_FAIL = 'LOGIN_SIG_FAIL'
export const INFO_SIG = 'INFO_SIG'

//LIMPA MSGS

export const LIMPA_MSGS = 'LIMPA_MSGS'

//EVIDENCIA
export const EXIBIR_EVIDENCIA = 'EXIBIR_EVIDENCIA'
export const EXIBIR_EVIDENCIA_SUCCESS = 'EXIBIR_EVIDENCIA_SUCCESS'
export const EXIBIR_EVIDENCIA_FAIL = 'EXIBIR_EVIDENCIA_FAIL'

//USERS
export const USERS_LOAD = 'USERS_LOAD'
export const USERS_RESPONSE = 'USERS_RESPONSE'
export const UPDATE_UNIQUE_USER = 'UPDATE_UNIQUE_USER'

//RELATORIO
export const RELATORIO = 'RELATORIO'
